import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CodeUoM } from '@jms/model';
import { CODE_PICKER_SERVICE } from '@jms/ui/ui.code.picker.pro';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { CodePickerService } from '@jms/ui/ui.standalone.services/code.picker.service';
import * as Enumerable from 'linq';
import { map, Observable, of, tap } from 'rxjs';


// interface CodeUoMGrouping extends CodeUoM {
//   group: string;
// }

@Component({
  selector: 'code-uom-picker',
  templateUrl: './code.uom.picker.component.html',
  styleUrls: ['./code.uom.picker.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CodeUomPickerComponent, multi: true },
    CodePickerService
  ],
  standalone: false
})
export class CodeUomPickerComponent extends PickerBaseComponent implements OnInit, OnChanges {

  @Input() public data: CodeUoM[];
  @Input() public codeName: string;
  @Input() public placeholder = '<Code UoM>';
  @Input() public appendTo = '';
  @Input() public multiple = false;
  @Input() public clearable = true;

  @Output() public onChange = new EventEmitter<CodeUoM>();

  public data$: Observable<CodeUoM[]>;

  private static cache = new Map<string, CodeUoM[]>();
  private static isLoading = false;

  constructor(
    injector: Injector,
    @Inject(CODE_PICKER_SERVICE) private dataService: CodePickerService,
  ) {
    super(injector);
  }

  public async ngOnInit() { }

  public async ngOnChanges(changes: SimpleChanges) {

    if (this.fetch === PickerFetch.Automatic) {
      this.data$ = this.dataService
        .loadUoMsByCodeName(this.codeName)
        .pipe(
          map(x => x as any[])
        );
    } else {
      this.data$ = of(this.data).pipe(
        map(x => {

          return Enumerable.from(x)
            .select(x => {
              return { ...x, group: x?.group ?? x?.uom?.type }
            })
            .toArray()
        })
      )
    }
  }
  public onUoMChanged(uom: any) {
    this.onChange.emit(uom);
  }

  public loadOnDemand() {

    if (this.fetch !== PickerFetch.OnDemand)
      return;

    if (CodeUomPickerComponent.cache.has(this?.codeName)) {
      this.data$ = of(CodeUomPickerComponent.cache.get(this?.codeName));
    } else {
      this.data$ = this.dataService
        .loadUoMsByCodeName(this.codeName)
        .pipe(
          tap(x => CodeUomPickerComponent.cache.set(this.codeName, x))
        );
    }

  }

}
